import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import { Cidade } from "./cidadesService";

const urlBase = `${config.urlApi}/Parceiros`;  //import.meta.env.VITE_URL_API;

const urls = {
  obter: `${urlBase}`,
  obterPorId: `${urlBase}`,
  adicionar: `${urlBase}`,
  alterar: `${urlBase}`,
  excluir: `${urlBase}`,
  obterCategorias: `${urlBase}/Categorias`,
}

function resolverUrlFoto(item: Parceiro): Parceiro {
  if (item.arquivo != null && item.arquivo != "") {
    item.arquivo = `${config.urlApi}/parceiros/${item.parceiroId}/${item.arquivo}`;
  }
  return item;
}


function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

export const obterPorId = (id: number): Promise<Parceiro> => {
  return new Promise((resolve, reject) => {

    const params = {
      id: id
    }

    console.log("obterPorId", id);
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urls.obterPorId}/${id}`, { params })
      .then((response) => {
        return resolve(resolverUrlFoto(response.data));
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter por id")));
  });
};

export const obter = (params?: Filtros | null | any): Promise<Grid> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter, { params })
      .then((r) => {
        r.data.dados.forEach(resolverUrlFoto);
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export async function salvar(model: Parceiro): Promise<Parceiro> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();

    if (model.parceiroId && model.parceiroId > 0) {
      return (await axios.put(`${urls.alterar}/${model.parceiroId}`, model)).data
    } else {
      return (await axios.post(urls.adicionar, model)).data
    }
  } catch (error: any) {
    throw new ApiException(error || "Falha ao salvar ");
  }
}

export async function excluir(id: number): Promise<void> {
  await axios.delete(`${urls.excluir}/${id}`)
}

export const uploadFoto = (id: number, arquivo: File): Promise<string> => {
  return new Promise((resolve, reject) => {

    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('arquivo', arquivo);

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(`${urlBase}/UploadFoto?id=${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao fazer upload da foto")));
  });
};

export const obterCategorias = (): Promise<Categoria[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.obterCategorias)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export interface Grid {
  dados: Array<Parceiro>,
  totalRegistros: number
}

export interface Filtros {
  parceiroId: number | null;
  nome: string | null;
  cnpj: string | null;
  ativo: boolean | null;
  voucher: boolean | null;
  telefone: string | null;
  cidadeId: number | null;
  usuarioId: number | null;
  paginaAtual: number | null;
  tamanhoPagina: number | null;
}

export interface Parceiro {
  parceiroId: number;
  usuarioId?: number | null;
  nome?: string;
  categoriaId?: number;
  cnpj?: string | null;
  logradouro?: string | null;
  numero: string | null;
  bairro: string | null;
  cidadeId: number | null;
  uF: string | null;
  cep: string | null;
  complemento: string | null;
  telefone: string | null;
  celular: string | null;
  valorDescontoIni: number | null;
  valorDesconto: number | null;
  voucher: boolean;
  ativo: boolean;
  texto: string | null;
  textoContrato: string | null;
  foto: string | null;
  arquivo: string | null;
  dataAssinatura: string | null;
  assinatura: string | null;
  responsavel: string | null;
}

export interface Categoria  {
    categoriaId: number;
    descricao: string;
    ativo: boolean;
}

